import { ca } from '@cian/analytics';
import { getAnalyticsSiteType, getClientDeviceType } from '../../../../../../shared/utils';

export const trackPhotoLoadSuccess = (trackingCategory, deviceType, formId) => {
  const siteType = getAnalyticsSiteType(deviceType);

  ca('eventSite', {
    name: 'oldevent',
    category: trackingCategory,
    action: 'photo_upload',
    label: 'success',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackPhotoLoadError = (errorCode, trackingCategory, formId) => {
  const siteType = getClientDeviceType();

  ca('eventSite', {
    name: 'oldevent',
    category: trackingCategory,
    action: 'photo_upload',
    label: 'error',
    page: {
      pageType: 'AddForm',
      siteType,
      error_code: errorCode,
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackPhotoDeleteSuccess = (trackingCategory, deviceType, formId) => {
  const siteType = getAnalyticsSiteType(deviceType);

  ca('eventSite', {
    name: 'oldevent',
    category: trackingCategory,
    action: 'photo_delete',
    label: 'success',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackPhotosHintScrollToEnd = adAnalyticsCategory => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'hint_scroll_to_end',
    label: 'photos',
  });
};

export const trackDescriptionHintScrollToEnd = adAnalyticsCategory => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'hint_scroll_to_end',
    label: 'description',
  });
};
